// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-destinations-js": function componentSrcPagesDestinationsJs() {
    return import("./../../src/pages/destinations.js"
    /* webpackChunkName: "component---src-pages-destinations-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-shop-js": function componentSrcPagesShopJs() {
    return import("./../../src/pages/shop.js"
    /* webpackChunkName: "component---src-pages-shop-js" */
    );
  },
  "component---src-templates-destination-js": function componentSrcTemplatesDestinationJs() {
    return import("./../../src/templates/destination.js"
    /* webpackChunkName: "component---src-templates-destination-js" */
    );
  },
  "component---src-templates-page-js": function componentSrcTemplatesPageJs() {
    return import("./../../src/templates/page.js"
    /* webpackChunkName: "component---src-templates-page-js" */
    );
  },
  "component---src-templates-post-category-base-page-js": function componentSrcTemplatesPostCategoryBasePageJs() {
    return import("./../../src/templates/postCategoryBasePage.js"
    /* webpackChunkName: "component---src-templates-post-category-base-page-js" */
    );
  },
  "component---src-templates-post-category-page-js": function componentSrcTemplatesPostCategoryPageJs() {
    return import("./../../src/templates/postCategoryPage.js"
    /* webpackChunkName: "component---src-templates-post-category-page-js" */
    );
  },
  "component---src-templates-post-js": function componentSrcTemplatesPostJs() {
    return import("./../../src/templates/post.js"
    /* webpackChunkName: "component---src-templates-post-js" */
    );
  },
  "component---src-templates-posts-page-js": function componentSrcTemplatesPostsPageJs() {
    return import("./../../src/templates/postsPage.js"
    /* webpackChunkName: "component---src-templates-posts-page-js" */
    );
  },
  "component---src-templates-product-category-js": function componentSrcTemplatesProductCategoryJs() {
    return import("./../../src/templates/productCategory.js"
    /* webpackChunkName: "component---src-templates-product-category-js" */
    );
  }
};